var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"app-wrapper"},[_c('app-header',{staticClass:"head",attrs:{"topVal":_vm.navBarFixed}}),_c('app-main',{staticClass:"app-main"}),_c('app-footer')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }